//
// WikiArticle
//

$('body.wiki').scrollspy({ target: '#section-navigation' });